<template>
  <div class="bg_login">
    <div class="login_title">
      <img src="../assets/bg2.png">
    </div>
    <div class="login_container">
      <div class="login_bg">
        <img src="../assets/bg1.png">
      </div>
      <div class="login_box">
        <!-- 注册账号 -->
        <router-link to="/login" class="login"><span class="el-icon-arrow-left">返回登录</span></router-link>
        <el-form ref="registerRef" :model="registerForm" :rules="registerFormRules" label-width="0px"
          class="login_form">
          <!-- 角色 -->
          <div class="login_header_title">
            <span>账号注册</span>
          </div>
          <el-form-item>
            <el-select v-model="registerForm.roleId" style="width:100%">
              <el-option v-for="item in RoleOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 学号或工号 -->
          <el-form-item prop="account">
            <el-input v-model="registerForm.account" placeholder="请输入学号或者工号" prefix-icon="iconfont icon-xingming">
            </el-input>
          </el-form-item>
          <!-- 单位 -->
          <el-form-item>
            <el-select v-model="registerForm.cpyId" placeholder="请选择单位/院校" style="width:100%">
              <el-option v-for="item in UnitOptions" :key="item.cpyId" :label="item.name" :value="item.cpyId">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 手机号 -->
          <el-form-item prop="phone">
            <el-input v-model="registerForm.phone" placeholder="请输入手机号"
              prefix-icon="iconfont icon-jibenicon_shouji-mian"></el-input>
          </el-form-item>
          <!-- 验证码 -->
          <el-form-item prop="checkCode">
            <el-col class="code">
              <el-input v-model="registerForm.checkCode" placeholder="请输入验证码" prefix-icon="iconfont icon-duanxinguanli">
                <span class="yz" v-show="show" slot="suffix" @click="getCode">获取验证码</span><span class="yz"
                  v-show="!show" slot="suffix">{{ count }}s</span>
              </el-input>
            </el-col>
          </el-form-item>
          <!-- 姓名 -->
          <el-form-item prop="name">
            <el-input v-model="registerForm.name" placeholder="请输入姓名" prefix-icon="iconfont icon-xingming"></el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item prop="password">
            <el-input v-model="registerForm.password" placeholder="请输入密码" prefix-icon="iconfont icon-mima1"></el-input>
          </el-form-item>
          <!-- 按钮区域 -->
          <div class="btns" @click="register">
            注册
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show: true,
        count: '',
        timer: null,
        // 角色
        RoleOptions: [],
        // 单位
        UnitOptions: [{
            value: '0',
            label: '中南医院'
          },
          {
            value: '1',
            label: '协和医院'
          }
        ],
        // 注册表单的数据绑定对象
        registerForm: {
          cpyId: '',
          roleId: '',
          account: '',
          phone: '',
          checkCode: '',
          name: '',
          password: ''
        },
        // 这是注册的验证规则对象
        registerFormRules: {
          // 验证学号是否合法
          account: [{
              required: true,
              message: '请输入学号或者工号',
              trigger: 'blur'
            }
            // {
            //   min: 6,
            //   max: 15,
            //   message: '长度在 6 到 15 个字符',
            //   trigger: 'blur'
            // }
          ],
          // 验证手机号是否合法
          phone: [{
              required: true,
              message: '请输入手机号',
              trigger: 'blur'
            },
            {
              min: 11,
              max: 11,
              message: '手机号错误',
              trigger: 'blur'
            }
          ],
          // 验证码是否合法
          checkCode: [{
              required: true,
              message: '请输入验证码',
              trigger: 'blur'
            },
            {
              min: 6,
              max: 6,
              message: '验证码错误',
              trigger: 'blur'
            }
          ],
          // 验证名字是否合法
          name: [{
              required: true,
              message: '请输入名字',
              trigger: 'blur'
            },
            {
              min: 0,
              max: 16,
              message: '名字长度不超过16位',
              trigger: 'blur'
            }
          ],
          // 验证密码是否合法
          password: [{
              required: true,
              message: '请输入密码',
              trigger: 'blur'
            },
            // {
            //   min: 6,
            //   max: 20,
            //   message: '密码为6到20位英文字母和数字组合',
            //   trigger: 'change'
            // }
          ]
        }
      }
    },
    created() {
      this.getRoleList()
      this.getUnitList()
      // console.log(this.UnitOptions);
      // console.log(this.RoleOptions);
      // this.registerForm.cpyId = this.UnitOptions[0].cpyId
      // this.registerForm.roleId = this.RoleOptions[0].rid
    },
    methods: {
      // 角色
      async getRoleList() {
        const {
          data: res
        } = await this.$http.get('role/register')
        if (res.result !== 0) {
          return this.$message.error('获取用户列表失败！')
        }
        console.log(res)
        this.RoleOptions = res.data
        this.registerForm.roleId = this.RoleOptions[0].rid
        console.log(this.RoleOptions)
      },
      // 单位
      async getUnitList() {
        const {
          data: res
        } = await this.$http.get('company/list', {
          params: {
            pageNum: 1,
            pageSize: 99999
          }
        })
        if (res.result !== 0) {
          return this.$message.error('获取单位列表失败！')
        }
        console.log(res)
        this.UnitOptions = res.data.list
        this.registerForm.cpyId = this.UnitOptions[0].cpyId
        console.log(this.UnitOptions)
      },
      // 注册
      register() {
        console.log(this.registerForm)
        this.$refs.registerRef.validate(async valid => {
          if (!valid) return
          const {
            data: res
          } = await this.$http.post('auth/register', this.registerForm)
          console.log(res)
          if (res.result == 0) {
            this.$message.success('注册成功！')
            this.$router.push('/login')
            return
          }
          this.$message.error(res.msg)
          // 1. 将登录成功之后的 token，保存到客户端的 sessionStorage 中
          //   1.1 项目中出了登录之外的其他API接口，必须在登录之后才能访问
          //   1.2 token 只应在当前网站打开期间生效，所以将 token 保存在 sessionStorage 中
          // window.sessionStorage.setItem('token', res.data.token)
          // // 2. 通过编程式导航跳转到后台主页，路由地址是 /home
        })
      },
      async getCode() {
        const TIME_COUNT = 60
        console.log(this.registerForm.phone)
        console.log(this.$md5('czkj-2021' + this.registerForm.phone + '2021-czkj'))
        const {
          data: res
        } = await this.$http.get('phone/send/checkcode', {
          params: {
            phone: this.registerForm.phone,
            deviceToken: this.$md5('czkj-2021' + this.registerForm.phone + '2021-czkj'),
            type: 1
          }
        })
        console.log(res)
        if (res.result == 0) {
          this.$message.success('发送成功！')
          const TIME_COUNT = 60
          if (!this.timer) {
            this.count = TIME_COUNT
            this.show = false
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.show = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
        }
        this.$message.error(res.msg)
      }
    }
  }
</script>

<style lang="less" scoped>
  .login_title {
    height: 75px;
    width: 1200px;
    max-width: 90%;
    margin: 27px auto 0;

    img {
      width: 100%;
    }
  }

  .bg_login {
    background-image: url(../assets/bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 100%;
    width: 100%;
    min-height: 100%;
    overflow: hidden;
    margin: 0 auto;
  }

  .login_container {
    // background-image: url(../assets/bg.png);
    height: 100%;
    width: 1200px;
    max-width: 90%;

    min-height: 100%;
    overflow: hidden;
    margin: 0 auto;
    display: flex;
    box-sizing: border-box;
    // align-items: center;

  }

  .login_bg {

    width: 46rem;
    height: 32rem;
    margin-top: 7.625rem;

    img {
      width: 100%;
    }
  }

  .login_box {
    width: 19rem;
    height: 37rem;
    margin-left: 25px;
    border: 3px solid #5987ca;
    // position: relative;
    background-color: #FFFFFF;
    .login_header_title {
      // position: absolute;
      // top: 20px;
      width: 100%;
      text-align: center;
      // padding: 0 30px;
      display: inline-block;
      margin-bottom: 20px;

      span {
        display: inline-block;
        width: 85px;
        text-align: center;
        // margin: 0 40px;
        margin-top: 2px;
        font-size: 20px;
        font-weight: 600;
      }
    }

    span {
      font-size: 14px;
    }
  }

  .login_form {
    // position: absolute;
    // top: 2px;
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
  }

  .btns {
    display: flex;
    // justify-content: flex-end;
    justify-content: center;
    width: 100%;
    height: 45px;
    line-height: 45px;
    border-radius: 5px;
    background-color: rgb(0, 122, 221, 1);
    margin-top: 30px;
    color: #ffffff;
    cursor: pointer;
  }

  .code {
    margin-right: 80px;
  }

  .zhuce {
    width: 100%;
    display: flex;
    justify-content: space-between;

    span {
      cursor: pointer;
    }

    span:nth-child(2) {
      color: var(--color-primary);
    }
  }

  .on {
    height: 25px;
    border-bottom: 1px solid #0086b3;
  }

  .yz {
    display: inline-block;
    color: var(--color-primary);
    margin-right: 3px;
    cursor: pointer;
  }

  .weixin {
    width: 30px;
    height: 30px;
    position: absolute;
    bottom: 0;
    left: 20px;

    img {
      width: 100%;
    }
  }

  .login {
    span {
      display: inline-block;
      margin: 10px 10px;
      color: var(--color-primary);
      font-size: 16px;
      font-weight: 600;
    }

    // box-sizing: border-box;
  }
</style>
